<template>
    <div>
        <SearchBar @statementSearch="doStatementSearch" />
        <CCard>
            <CCardBody>
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center">{{headers[6]}}</th>
                            <th class="text-center">{{headers[7]}}</th>
                            <th class="text-center">{{headers[8]}}</th>
                            <th class="text-center">{{headers[9]}}</th>
                            <th class="text-center">{{headers[10]}}</th>
                            <th class="text-center">{{headers[11]}}</th>
                            <th class="text-center">{{headers[12]}}</th>
                            <th class="text-center">{{headers[13]}}</th>
                            <th class="text-center">{{headers[14]}}</th>
                            <th class="text-center">{{headers[15]}}</th>
                            <th class="text-center">{{headers[16]}}</th>
                            <th class="text-center">{{headers[17]}}</th>
                            <th class="text-center">{{headers[18]}}</th>
                            <th class="text-center text-danger bg-yellow">{{headers[19]}}</th>
                            <th class="text-center">{{headers[20]}}</th>                            
                            <th class="text-center text-danger bg-yellow">{{headers[21]}}</th>
                            <th class="text-center">{{headers[22]}}</th>
                            <th class="text-center">{{headers[23]}}</th>
                            <th class="text-center">{{headers[24]}}</th>
                            <th class="text-center">{{headers[25]}}</th>
                            <th class="text-center">{{headers[26]}}</th>
                            <th class="text-center">{{headers[27]}}</th>
                            <th class="text-center">{{headers[28]}}</th>
                            <th class="text-center">{{headers[29]}}</th>
                            <th class="text-center">{{headers[30]}}</th>
                            <th class="text-center">{{headers[31]}}</th>   
                            <th class="text-center">{{headers[32]}}</th>                            
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in statementSearchResult" :key="index" :class="getSumTrcss(item)">
                            <td class="text-center">{{item.factoryName}}</td>
                            <td class="text-center">{{item.ekorg}}</td>
                            <td class="text-center">{{item.lifnr}}</td>
                            <td class="text-center">{{item.customerName}}</td>
                            <td class="text-center">{{gteErdatSt_Ed(item)}}</td>
                            <td class="text-center">{{fixDate(item.budat1)}}</td>
                            <td class="text-center">{{item.livTyp}}</td>
                            <td class="text-center">{{item.ekgrp}}</td>          
                            <td class="text-center">{{item.bwart}}</td>
                            <td class="text-center">{{item.action}}</td>
                            <td class="text-center">{{item.ddtno}}</td>
                            <td class="text-center">{{item.ddtlp}}</td>
                            <td class="text-center">{{item.bsart}}</td>
                            <td class="text-center">{{item.ebeln}}</td>
                            <td class="text-center">{{item.ebelp}}</td>
                            <td class="text-center">{{item.matnr}}</td>
                            <td class="text-center">{{item.txz01}}</td>
                            <td class="text-center">{{item.groes}}</td>
                            <td class="text-center">{{item.waers}}</td>
                            <td class="text-center text-danger bg-yellow">{{item.netpr1 | currencyF5 }}</td>
                            <td class="text-center">{{item.rgmng | currencyF3}}</td>
                            <td class="text-center text-danger bg-yellow">{{item.rgtpr | currencyF2 }}</td>
                            <td class="text-center">{{item.lgort}}</td>
                            <td class="text-center">{{item.invno}}</td>
                            <td class="text-center">{{item.autono}}</td>
                            <td class="text-center">{{item.matkl}}</td>
                            <td class="text-center">{{item.wgbez}}</td>
                            <td class="text-center">{{item.zzlifnr2}}</td>
                            <td class="text-center">{{item.zzname2}}</td>
                            <td class="text-center">{{item.knttp}}</td>
                            <td class="text-center">{{item.zeikto}}</td>
                            <td class="text-center">{{item.mwskz}}</td>
                            <td class="text-center">{{item.kbetr | currencyF2}}{{showPercentage(item.kbetr)}}</td>
                            
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import SearchBar from './SearchBar'
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    mixins: [orderMixin],
    data() {
        return {
            headers : [
                this.i18n('CheckedStatement.Factory'),
                this.i18n('CheckedStatement.PurchaseOrg'),
                this.i18n('CheckedStatement.VendorCode'),
                this.i18n('CheckedStatement.Vendor'),
                this.i18n('CheckedStatement.PaymentRange'),
                this.i18n('CheckedStatement.PostingDate'),
                this.i18n('CheckedStatement.InvoicingType'),
                this.i18n('CheckedStatement.PurchaseGroup'),
                this.i18n('CheckedStatement.MovementType'),
                this.i18n('CheckedStatement.MovementText'),

                this.i18n('CheckedStatement.MaterialDocument'),
                this.i18n('CheckedStatement.MaterialDocumentItem'),
                this.i18n('CheckedStatement.DocumentType'),
                this.i18n('CheckedStatement.PurchasingDocument'),
                this.i18n('CheckedStatement.PurchasingDocumentitem'),
                this.i18n('CheckedStatement.Material'),
                this.i18n('CheckedStatement.ShortText'),
                this.i18n('CheckedStatement.Specification'),
                this.i18n('CheckedStatement.Currency'),
                this.i18n('CheckedStatement.NetPrice'),

                this.i18n('CheckedStatement.GoodsReceiptQuantity'),
                this.i18n('CheckedStatement.GoodsReceiptAmount'),
                this.i18n('CheckedStatement.StorageLocation'),
                this.i18n('CheckedStatement.ImportInvoiceNo'),
                this.i18n('CheckedStatement.ManuscriptNumber'),
                this.i18n('CheckedStatement.MaterialGroup'),
                this.i18n('CheckedStatement.MaterialGroupDescription'),
                this.i18n('CheckedStatement.GoodsSupplierCode'),
                this.i18n('CheckedStatement.GoodsSupplier'),
                this.i18n('CheckedStatement.AccountAssignmentCategory'),

                this.i18n('CheckedStatement.PaymentRangeDescription'),
                this.i18n('CheckedStatement.TaxCode'),
                this.i18n('CheckedStatement.Tax'),
                this.i18n('CheckedStatement.ExchRate')
            ],
            statementSearchResult : [],
            statementQueryParam: {},
            lists: []
        }
    },
    components: {
        SearchBar,
    },    
    props : {
    },
    methods: {
        getSumTrcss(item){
            if(item && item.lifnr){
               return '';   
            }
            return 'table-warning';
        },
        doStatementSearch (queryParam){//對帳單 查詢
            const url = `${this.$apiUrl_Order}/SearchStatementAsync`
            const param= queryParam;
            const self =this;
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                
                    //--成功                   
                    const rows = [];                    
                    if(response.data && response.data.length >0){
                        //處理小記加總
                        const sumValue ={};
                        let lastGpKey= '';
                        response.data.forEach(r => {                            
                            const gpKey = r.werks4 + '\t' + r.ekorg+ '\t' + r.lifnr+ '\t'+ r.mwskz+ '\t'+ r.waers+ '\t'+ r.livTyp;
                            let calcVal =sumValue[gpKey];                            
                            if(calcVal){
                                calcVal.netpr1 += r.netpr1;
                                calcVal.rgtpr += r.rgtpr;                                
                            } else {                                
                                if(lastGpKey){
                                    //產生小計列
                                    let lastCalcVal =sumValue[lastGpKey];
                                    //rows.push({netpr1 : lastCalcVal.netpr1,rgtpr : lastCalcVal.rgtpr});
                                    rows.push({netpr1 : '',rgtpr : lastCalcVal.rgtpr});                                    
                                }
                                lastGpKey = gpKey;
                                sumValue[gpKey] = {netpr1 : '',rgtpr : r.rgtpr};
                            }
                            rows.push(r);
                        });
                        if(lastGpKey){
                            //產生小計列
                            let lastCalcVal =sumValue[lastGpKey];
                            //rows.push({netpr1 : lastCalcVal.netpr1,rgtpr : lastCalcVal.rgtpr});
                            rows.push({netpr1 : '',rgtpr : lastCalcVal.rgtpr});
                        }
                    }
                    self.statementSearchResult = rows; 
                    self.statementQueryParam = param;                    
                    self.setCacheQueryParam('Account_QueryParam' , param);
                }                    
            });
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
        gteErdatSt_Ed(item){
            if(item.erdatSt && item.erdatEd){
                return this.fixDate(item.erdatSt) + '~' + this.fixDate(item.erdatEd);
            }            
            return '';
        },
        showPercentage (v){
            if(v || v === 0){
                return '%'
            }
            return '';
        }
    },
    watch: {
        "lang": function() {
            this.headers = [
                this.i18n('CheckedStatement.Factory'),
                this.i18n('CheckedStatement.PurchaseOrg'),
                this.i18n('CheckedStatement.VendorCode'),
                this.i18n('CheckedStatement.Vendor'),
                this.i18n('CheckedStatement.PaymentRange'),
                this.i18n('CheckedStatement.PostingDate'),
                this.i18n('CheckedStatement.InvoicingType'),
                this.i18n('CheckedStatement.PurchaseGroup'),
                this.i18n('CheckedStatement.MovementType'),
                this.i18n('CheckedStatement.MovementText'),

                this.i18n('CheckedStatement.MaterialDocument'),
                this.i18n('CheckedStatement.MaterialDocumentItem'),
                this.i18n('CheckedStatement.DocumentType'),
                this.i18n('CheckedStatement.PurchasingDocument'),
                this.i18n('CheckedStatement.PurchasingDocumentitem'),
                this.i18n('CheckedStatement.Material'),
                this.i18n('CheckedStatement.ShortText'),
                this.i18n('CheckedStatement.Specification'),
                this.i18n('CheckedStatement.Currency'),
                this.i18n('CheckedStatement.NetPrice'),

                this.i18n('CheckedStatement.GoodsReceiptQuantity'),
                this.i18n('CheckedStatement.GoodsReceiptAmount'),
                this.i18n('CheckedStatement.StorageLocation'),
                this.i18n('CheckedStatement.ImportInvoiceNo'),
                this.i18n('CheckedStatement.ManuscriptNumber'),
                this.i18n('CheckedStatement.MaterialGroup'),
                this.i18n('CheckedStatement.MaterialGroupDescription'),
                this.i18n('CheckedStatement.GoodsSupplierCode'),
                this.i18n('CheckedStatement.GoodsSupplier'),
                this.i18n('CheckedStatement.AccountAssignmentCategory'),

                this.i18n('CheckedStatement.PaymentRangeDescription'),
                this.i18n('CheckedStatement.TaxCode'),
                this.i18n('CheckedStatement.Tax'),
                this.i18n('CheckedStatement.ExchRate')
            ]
        }
    },
    computed: {
        ...mapGetters(['lang'])
    },
	mounted() {
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.card-body {
    overflow-x: auto;
}

.bg-yellow {
    background-color: #FFFF00 !important;
    font-weight: 900;
}

.table-warning {
    background-color: #FFFF00 !important;
}
.table-warning, .table-warning>td, .table-warning>th {
    background-color: #FFFF00 !important;
}
</style>


